import { createContext } from "react";

const FaqContext = createContext(null);

export default FaqContext;
